import { render, staticRenderFns } from "./selectAyXW.vue?vue&type=template&id=34a1008b&scoped=true&"
import script from "./selectAyXW.vue?vue&type=script&lang=js&"
export * from "./selectAyXW.vue?vue&type=script&lang=js&"
import style0 from "./selectAyXW.vue?vue&type=style&index=0&id=34a1008b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a1008b",
  null
  
)

export default component.exports